export default __webpack_public_path__ + "images/pw-5f3d8d8e8473f6439a214096e59c7636.svg";